
import $ from "jquery";
import moment from "moment";
import DataTable from "datatables.net-bs5";
import Scroller from 'datatables.net-scroller'
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import {initPopper} from "@/modules/popper";
import {createGeoJsonLayer, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";
import toastr from "toastr"
import {
    getBookmarkPresentationsByID, getLayerByName, getLayerSourceParams, getProjectionByBookmarkPresentationID,
    removeLayersIncludes, updateBookmarkPresentationByID,
    updateLayerSourceParams
} from "@/helpers/ol/ol-layer-helper";
import {viewFit} from "@/helpers/ol/ol-view";
import {getActiveFilter, getExportExtensions, getFilterVectorLayerStyle} from "@/helpers/filter/filter-helper";
import {getDataTableFilterSettings} from "@/helpers/filter/filter-settings-helper";
import {callService} from "@/helpers/ol/ol-http-helper";
import {zoomToFeature} from "@/helpers/ol/ol-zoom-helper";
import {filterDownload} from "@/http/services/http-services-filter";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {transformExtent} from "ol/proj";
import {getToken} from "@/helpers/auth/auth-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {escapeOutput, unEscapeOutput} from "@/helpers/output-helper";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {
    getDataTableEditorFormButtons,
    getDataTableEditorOptions,
    initEditor
} from "@/helpers/datatable/datatable-editor-helper.js";
import {initDataTableEditorEvents} from "@/helpers/datatable/datatable-editor-event-helper.js";
import {getDefaultFilterStyleFunction, getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper.js";
import DOMPurify from "dompurify";

moment.locale('nl')
let localTable = undefined
let init
let localUrl
let activeIndex
let activeIndexText
let maxIndex
let currentScrollerIndex
let selected = true
let table

/**
 * initDataTableFilter
 * @param url
 * @param columns
 * @param name
 */
export function initDataTableFilter(url, columns, name = null) {
    $.fn.dataTable.ext.errMode = 'none';

    init = true
    localUrl = url

    const activeFilter = getActiveFilter()
    const scrollY = 'calc(100vh - 400px)'

    const order = []
    const filter = activeFilter.Filter.filter;
    let orderDirection = 'asc';
    if (filter.Sortering === 2) {
        orderDirection = 'desc'
    }

    String(filter.Attributes).split(',').map((orderColumn) => {
        const column = columns.findIndex(column => column.id === parseInt(orderColumn))
        if (column >= 0) {
            order.push([column, orderDirection])
        }
    })

    const headers = {}
    const token = getToken()
    if (token !== undefined) {
        headers.Authorization = token
    }

    let displayBuffer = 2

    let scroller = false
    let pageLength = 0

    // Virtual scroll
    if(filter.MaxFeatures > 0) {
        pageLength = filter.MaxFeatures
    // Paging
    } else {
        scroller = {
            boundaryScale: 1,
            displayBuffer: displayBuffer,
            serverWait: 200,
            loadingIndicator: false
        }
    }

    let sInfo = '_START_ tot _END_ van _TOTAL_ resultaten'

    const formMutation = activeFilter.form.form_mutation

    let select = 'multi'
    let editor
    let dataTable
    let editorOptions
    if (formMutation) {

        if(formMutation.FormTypeID === 17) {
            select = true
        }

        dataTable = activeFilter.form.form_mutation
        dataTable.DomainID = activeFilter.DomainID
        dataTable.PresentationID = activeFilter.PresentationID

        if(activeFilter.PresentationLinkedID) {
            dataTable.PresentationID = activeFilter.PresentationLinkedID
        }

        if(activeFilter.FormID) {
            dataTable.FormID = activeFilter.FormID
        } else {
            dataTable.FormID = activeFilter.FormLinkedID
        }

        editorOptions = getDataTableEditorOptions(dataTable, name)
        editor = initEditor(dataTable, name, editorOptions)
    }

    const options = {
        initComplete: function () {
            if(scroller) {
                $('#tblFilter_paginate').parent().remove()
            }

            const element = document.getElementById('tblFilter_wrapper')
            const tblFilter_paginate = document.getElementById('tblFilter_paginate')
            if(tblFilter_paginate) {
                tblFilter_paginate.parentElement.classList.remove('col-md-7')
            }
            if (element) {
                element.querySelectorAll('.col-md-6').forEach(element => {
                    element.classList.remove('col-md-6')
                })
            }
        },
        processing: true,
        serverSide: true,
        pageLength: pageLength,
        scroller: scroller,
        order: order,
        deferRender: true,
        scrollY: scrollY,
        scrollCollapse: false,
        autoWidth: false,
        columnDefs: [{
            targets: '_all',
            createdCell: function (td, cellData) {
                if (typeof cellData === 'string') {
                    td.innerHTML = DOMPurify.sanitize(cellData);
                }
            }
        }],
        fixedColumns: true,
        fixedHeader: true,
        scrollX: true,
        searching: false,
        select: select,
        ajax: {
            type: 'post',
            url: url,
            headers: headers,
            data: function (d) {
                window.filterData = getDataTableFilterSettings(d)

                setTimeout(() => {
                    // window.filterData = getDataTableFilterSettings(d)
                }, 0)
            },
            complete: function (data) {
                const json = data.responseJSON
                const jsonFilter = json.filter
                maxIndex = json.recordsTotal
                delete window.filterTableExtent
                delete window.filterTableExtentProjection

                if (json.bbox && json.bbox[0] !== '') {
                    const bbox = []
                    json.bbox.map(bboxItem => {
                        bbox.push(Number(bboxItem))
                    })
                    window.filterTableExtent = bbox
                    window.filterTableExtentProjection = json.bboxprojection

                    if (window.filterTableExtent) {
                        zoomToFilterExtent()
                    }
                }

                if (window.filterTableExtent) {
                    showElementsBySelector('#btnFilterViewFit')
                } else {
                    hideElementsBySelector('#btnFilterViewFit')
                }

                window.filterTableFilter = jsonFilter

                toggleFilterMark()

                if (!selected) {
                    localTable.row(activeIndex).select();
                    selected = true
                }

                document.getElementById('tblFilter_info')?.parentElement?.classList.remove('col-md-5')
                $('#tblFilter .dataTables_scrollBody')?.height($('#tblFilter tbody').height() + 30)
            },
            error: function (xhr, status, error) {
                document.getElementById("divLayerErrorMessage").innerHTML = '<i class="fas fa-exclamation-triangle" style="margin-right: 2px;"></i>Resultaten kunnen niet worden opgehaald.';

                $('#' + name).parents('#divLayerInfoFilterResult').first().hide();

                $('.dataTables_processing').hide();

                console.error('DataTables AJAX error:', status, error);

                document.addEventListener('click', function handleClick() {
                    document.getElementById("divLayerErrorMessage").innerHTML = '';

                    $('#' + name).parents('#divLayerInfoFilterResult').first().show();

                    document.removeEventListener('click', handleClick);
                }, { once: true });
            }
        },
        columns: columns,
        language: {
            "sProcessing": "",
            "sLengthMenu": "_MENU_ resultaten weergeven",
            "sZeroRecords": "Geen resultaten gevonden",
            "sInfo": sInfo,
            // "sInfo": "Er zijn _TOTAL_ resultaten",
            "sInfoEmpty": "Geen resultaten om weer te geven",
            // "sInfoEmpty": "Geen resultaten om weer te geven",
            "sInfoFiltered": " (gefilterd uit _MAX_ resultaten)",
            "sInfoPostFix": "",
            "sSearch": "Zoeken:",
            "sEmptyTable": "Geen resultaten aanwezig in de tabel",
            "sInfoThousands": ".",
            "sLoadingRecords": "Een moment geduld aub - bezig met laden...",
            "oPaginate": {
                "sFirst": "Eerste",
                "sLast": "Laatste",
                "sNext": "Volgende",
                "sPrevious": "Vorige"
            },
            "oAria": {
                "sSortAscending": ": activeer om kolom oplopend te sorteren",
                "sSortDescending": ": activeer om kolom aflopend te sorteren"
            },
            select: {
                rows: {
                    _: "",
                    0: "",
                    1: ""
                    // _: "%d items geselecteerd",
                    // 0: "Klik op een item om het te selecteren",
                    // 1: "1 item geselecteerd"
                }
            }
        }
    }

    const tableButtons = []

    let presentationID = activeFilter.PresentationID
    if(activeFilter.PresentationLinkedID) {
        presentationID = activeFilter.PresentationLinkedID
    }

    table = new DataTable($('#' + name), options);

    table.on('select', function (e, dt, type, indexes) {

        if(getBySelector('#chbFilterCheckbox')?.checked) {

            const data = table.row(indexes[0]).data()

            if(data !== undefined) {
                const feature = getFeatureByData(data)
                feature.projection = getProjectionByBookmarkPresentationID(activeFilter.BookmarkPresentationID)
                createGeoJsonLayer(feature, 'filter_select' + indexes[0], true, undefined, undefined, undefined, 10001)
            }

            return
        }

        if(editor) {
            return
        }

        var rowData = table.rows(indexes).data().toArray();
        activeIndex = indexes[0]

        if(!document.querySelector('layer-info-filter').classList.contains('d-none')) {
            if(filter.MaxFeatures > 0) {
                activeIndexText = indexes[0]
            } else {
                activeIndexText = table.scroller.page().start + indexes[0]
            }
        }

        callService(activeFilter.BookmarkPresentationID, rowData[0].featureid, 'wfs', activeFilter.DomainID, presentationID, undefined, undefined, true)
        rowData[0].geometry = rowData[0].geom

        const geometryAttribute = activeFilter.form.form_attributes.find(attribute => attribute.attribute.Type === 21)

        if(geometryAttribute) {
            rowData[0].geometry = rowData[0][geometryAttribute.attribute.Attribute]
        }

        if(rowData[0].geometrie) {
            rowData[0].geometry = rowData[0].geometrie
        }

        if(rowData[0].geometry) {
            let zoomFactor = activeFilter.Filter.filter.ZoomFactor
            if(!zoomFactor) {
                zoomFactor = window.map.getView().getZoom()
            }

            rowData[0].projection = getProjectionByBookmarkPresentationID(activeFilter.BookmarkPresentationID)

            zoomToFeature(rowData[0], zoomFactor, 1000)
        }
    })
    .on('deselect',function (e, dt, type, indexes) {
        if(getBySelector('#chbFilterCheckbox')?.checked) {
            removeLayersIncludes('filter_select' + indexes[0])
        }
    }).on('mouseleave', 'tbody tr', function () {
        removeLayersIncludes('filter_hover')
    }).on('mouseenter', 'tbody tr', function () {
        removeLayersIncludes('filter_hover')

        const data = table.row(this).data()

        if(data !== undefined) {
            const feature = getFeatureByData(data)
            feature.projection = getProjectionByBookmarkPresentationID(activeFilter.BookmarkPresentationID)
            createGeoJsonLayer(feature, 'filter_hover', true)
        }
    });

    getExportExtensions(activeFilter).map(exportExtension => {
        exportExtension = exportExtension.export_extension
        tableButtons.push({
            text: exportExtension.DisplayName,
            className: 'd-none',
            action: function () {

                let featureIds = []
                if(getBySelector('#chbFilterCheckbox')?.checked) {
                    table.rows({selected: true}).every( function ( rowIdx, tableLoop, rowLoop ) {
                        const data = this.data();

                        if(data.featureid) {
                            featureIds.push(data.featureid)
                        }
                        // ... do something with data(), or this.node(), etc
                    } );
                }

                let downloadUrl = localTable.settings().ajax.url()
                downloadUrl = downloadUrl.replace('request=data', 'request=download');
                // Output format
                downloadUrl += '&output_format=' + exportExtension.ExportFormat;
                downloadUrl += '&server_type=' + exportExtension.GroupName;
                downloadUrl += '&name=' + exportExtension.DisplayName;

                blockUi('.info-menu-content', 0.5)
                toastr.info('De data wordt gedownload')
                const data = localTable.settings().ajax.params()

                data.columns.map((column) => {
                    const formAttribute = getActiveFilter().form.form_attributes.find(formAttribute => formAttribute.attribute.Attribute === column.data)
                    if(formAttribute.AttributeTypeID === 1001) {
                        column.search = {
                            value: '',
                            regex: false
                        }
                    }
                })

                if(featureIds.length > 0) {
                    data.featureids = featureIds
                }

                data.start = 0

                filterDownload(downloadUrl, data).then((response) => {
                    return response.blob()
                }).then((blob) => {
                    toastr.success('De data is gedownload')
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'download-' + moment().format('YYYY-MM-DD') + '.' + exportExtension.Extension
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove();  //afterwards we remove the element again
                    unblockUi('.info-menu-content')
                })
            },
            // className: 'btn btn-outline-danger btn-xs mt-1'
        })
    })

    if(editor) {
        initDataTableEditorEvents(dataTable, editor, editorOptions, undefined, table, null)

        if (dataTable.UserRights.includes(7)) {
            tableButtons.push({
                extend: "create",
                text: '<span class="fa fa-plus"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Toevoegen<div class="arrow" data-popper-arrow=""></div></div>',
                editor: editor,
                formButtons: getDataTableEditorFormButtons(),
                className: 'btn-outline-secondary icon-btn btn-sm popper-header'
            })
        }

        if (dataTable.UserRights.includes(3)) {
            tableButtons.push({
                extend: "edit",
                text: '<span class="fa fa-edit"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Bewerken<div class="arrow" data-popper-arrow=""></div></div>',
                editor: editor,
                formButtons: getDataTableEditorFormButtons('edit'),
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
            })
        }

        if (dataTable.UserRights.includes(8)) {
            tableButtons.push({
                extend: "remove",
                text: '<span class="fa fa-trash"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Verwijderen<div class="arrow" data-popper-arrow=""></div></div>',
                editor: editor,
                formButtons: getDataTableEditorFormButtons('remove'),
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
            })
        }

        if(formMutation.FormTypeID === 17) {
            tableButtons.push({
                extend: "selectAll",
                text: '<span class="fa fa-check-double"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Alles selecteren<div class="arrow" data-popper-arrow=""></div></div>',
                editor: editor,
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
            })
            tableButtons.push({
                extend: "selectNone",
                text: '<span class="fa fa-times"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Alles deselecteren<div class="arrow" data-popper-arrow=""></div></div>',
                editor: editor,
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
            })
        }

        tableButtons.push(
            {
                extend: "selectedSingle",
                editor: editor,
                text: '<span class="fa fa-info"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Meer informatie<div class="arrow" data-popper-arrow=""></div></div>',
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header',
                action: function () {
                    const data = table.row( { selected: true } ).data();

                    callService(activeFilter.BookmarkPresentationID, data.featureid, 'wfs', activeFilter.DomainID, presentationID, undefined, undefined, true)
                }
            }
        )
    }

    // Display the buttons
    new $.fn.dataTable.Buttons( table, tableButtons );

    table.buttons().container().appendTo( $('.col-md-6:eq(1)', table.table().container() ) );

    localTable = table

    window.filterTable = table

    initPopper()

    return table
}

export function reloadFilterDataTable() {
    if(localTable !== undefined) {
        localTable.ajax.url(localUrl).load();
        // localTable.ajax.reload()
    }
}

export function resetDataTable() {
    if(localTable !== undefined) {
        localTable.ajax.url(localUrl + '&reset=true').load();
    }
}

export function getActiveIndex() {
    return activeIndex
}

export function getMaxIndex() {
    return maxIndex
}

export function selectDataTableByType(type) {

    switch (type) {
        case 'first':
            activeIndex = 1
            break;
        case 'next':
            activeIndex++
            activeIndexText++
            if(activeIndex === maxIndex) {
                activeIndex = 0
                activeIndexText = 0
            }
            break;
        case 'previous':
            if(activeIndex === 0) {
                activeIndex = maxIndex - 1
                activeIndexText = maxIndex - 1
            } else {
                activeIndex--
                activeIndexText--
            }
            break;
        case 'last':
            activeIndex = maxIndex - 1
            break;
    }

    selectDataTableByIndex(type)
}

export function selectDataTableByIndex(type) {
    localTable.rows().deselect();
    var row = localTable.row(activeIndex);
    selected = false
    if (row != null && row.length > 0) {
        row.select();
        selected = true
    } else {
        if(type === 'next') {
            localTable.row(activeIndex - 1).scrollTo(false)
            activeIndex = 0
        } else {
            localTable.scroller.toPosition( activeIndexText - 3, false )
            activeIndex = 3
        }
    }
}

export function getActiveIndexText() {
    return activeIndexText
}

export function zoomToFilterExtent() {
    if(window.filterTableExtent && window.filterTableExtent[0] > 0) {
        const extent = new transformExtent(window.filterTableExtent, window.filterTableExtentProjection, getViewProjectionName())

        const activeFilter = getActiveFilter()

        let zoomFactor = undefined
        if(activeFilter) {
            zoomFactor =  getActiveFilter().Filter.filter.ZoomFactor
        }

        // console.log(extent)
        viewFit(
            extent,
            undefined,
            zoomFactor,
            0,
            true
        )
    }
}

/**
 *  * @param click
 */
export function toggleFilterMark(click = false) {

    const chbFilterMark = document.querySelector('#chbFilterMark')
    if(!chbFilterMark) {
        return
    }

    const checked = chbFilterMark.checked

    const activeFilter = getActiveFilter()

    if(!activeFilter) {
        return
    }

    if(checked && click && activeFilter.Filter.filter.MaxFeatures === 0) {
            localTable.ajax.url(localUrl + '&virtualScroll=false').load();
            return
    }
    const bookmarkPresentation = getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)

    let filter = ''
    let projection = getProjectionByBookmarkPresentationID(activeFilter.BookmarkPresentationID)
    if(checked) {
        removeLayersIncludes('filter_mark')
        const featureCollection = {}
        featureCollection.features = []
        featureCollection.type = 'FeatureCollection'
        table.rows().data().map(data => {
            const feature = {}
            feature.type = 'Feature'
            if(data.geom) {
                feature.geometry = data.geom
            } else if(data.geometrie) {
                feature.geometry = data.geometrie
            } else if(window.filter_geom_column) {
                feature.geometry = data[window.filter_geom_column]
            }
            feature.projection = projection

            featureCollection.features.push(feature)

            console.log(featureCollection)
        })

        createGeoJsonLayer(featureCollection, 'filter_mark', true, undefined, getDefaultFilterStyleFunction(), projection)
        if(bookmarkPresentation) {
            filter = bookmarkPresentation.Filter.Filter
        }
    } else {
        removeLayersIncludes('filter_mark')
        filter = window.filterTableFilter
    }

    if(bookmarkPresentation && bookmarkPresentation.Type === 'WMS' && filter !== undefined) {
        bookmarkPresentation.Filter.CQL_FILTER = getLayerSourceParams(activeFilter.BookmarkPresentationID)['CQL_FILTER']
        updateLayerSourceParams(activeFilter.BookmarkPresentationID, 'CQL_FILTER', bookmarkPresentation.Filter.CQL_FILTER)
        updateLayerSourceParams(activeFilter.BookmarkPresentationID, 'FILTER', filter)
    }
}

export function getDataTableFilterRows() {
    return table.rows().data()
}

export function getFilterMarkLayer() {
    return getLayerByName('activeGeoJson-filter_mark', false)
}

export function getFeatureByData(data) {
    const feature = {}
    if(data.geom) {
        feature.geometry = data.geom
    } else if(data.geometrie) {
        feature.geometry = data.geometrie
    } else if(window.filter_geom_column) {
        feature.geometry = data[window.filter_geom_column]
    }
    return feature;
}
